import { Component, Input } from '@angular/core';
import { Acte } from 'apps/idl/src/model/Acte';
import { ETaux } from '../../enums/ETaux';
import { SnackbarService } from '../../services/snackbar.service';
import { TAX_ALLOWANCE_MESSAGES } from 'apps/idl/src/anakin/shared/tax-allowance.constants';

@Component({
	selector: 'di-information-abattement',
	templateUrl: './information-abattement.component.html',
	styleUrls: ['./information-abattement.component.scss'],
})
export class InformationAbattementComponent{
	
	@Input()
	public acte: Acte;
	
	@Input()
	public close = () => {};
	
	@Input() changeTaux: (taux: string,isAuto : boolean) => void;

	@Input()
	public seanceDependance?: boolean;

	@Input()
	public disableAbattementManuel?: boolean;
	
	public tauxOptions = [
			{ label: "Auto", value: ETaux.AUTO},
			{ label: "100%", value: ETaux.CENT },
			{ label: "50%", value: ETaux.CINQUANTE },
			{ label: "Gratuit", value: ETaux.GRATUIT }
		]	
	taux : string;

	constructor( private svcSnackbar : SnackbarService) {}

	ngOnInit(): void {
		this.setTaxAllowanceExplication();
		if(this.acte.isAbattementForced){
			this.taux = this.acte.taxAllowanceForced === 0 ? ETaux.GRATUIT : String(this.acte.taxAllowanceForced);
		}else{
			this.taux = ETaux.AUTO
		}
	}

	public setTaxAllowanceExplication(): void {
		if(!this.acte.taxAllowanceExplication){
			const taxAllowance = this.acte.taxAllowance;
			this.acte.taxAllowanceExplication = TAX_ALLOWANCE_MESSAGES.T_AUTO(taxAllowance * 100);
		}
    }

	onTauxChange = (taux: string) => {	
		this.taux = taux;
		let message: string;
		if(this.acte.isAbattementForced && taux === ETaux.AUTO)
			message = "Tous les taux sont passés en automatique.&nbsp;"
		else if(!this.acte.isAbattementForced && taux !== ETaux.AUTO)
			message = "Taux les taux sont passés à 100% en manuel.&nbsp;"
		if(message){
			this.svcSnackbar.showToast(
				"info",
				"bottom center",
				message,
				null,
				null,
				null,
				"5000"
			);  
		}

		if(this.changeTaux) this.changeTaux(this.taux,this.taux === ETaux.AUTO);
	}
}
